var $6c16bf84cfa2b202$exports = {};
$6c16bf84cfa2b202$exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`,
    "sortAscending": `Sort Ascending`,
    "sortDescending": `Sort Descending`,
    "resizeColumn": `Resize column`,
    "columnResizer": `Column resizer`,
    "drag": `Drag`,
    "expand": `Expand`,
    "collapse": `Collapse`
};


export {$6c16bf84cfa2b202$exports as default};
//# sourceMappingURL=en-US.mjs.map
